export enum USER_ROLE {
  ADMIN = 'admin',
  GYM = 'gym',
  USER = 'user'
}
